import { ElementRef, EventEmitter, SimpleChanges, } from '@angular/core';
import { translateTouchEventToMouseEvent } from 'Angular/utils/dom-utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/components/inputs/color-picker/color-picker.component";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/simple-dropdown/simple-dropdown.component";
const _c0 = ["toolbar"];
const _c1 = ["toolbarDragHandle"];
function FundChartAnnotationStylingToolbarComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 10)(2, "div", 11);
    i0.ɵɵelement(3, "span", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "ycn-color-picker", 13);
    i0.ɵɵlistener("setColorHandler", function FundChartAnnotationStylingToolbarComponent_ng_container_2_Template_ycn_color_picker_setColorHandler_4_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectLineColor($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ycn-simple-dropdown", 14);
    i0.ɵɵlistener("handler", function FundChartAnnotationStylingToolbarComponent_ng_container_2_Template_ycn_simple_dropdown_handler_5_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectLineWeight($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", ctx_r2.selectedAnnotationName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("buttonClass", "btn-block")("currentColor", ctx_r2.selectedLineColor)("dropdownClass", "tool")("iconToggle", "icon-tool-line-color");
    i0.ɵɵadvance();
    i0.ɵɵproperty("buttonClass", "btn btn-secondary")("config", ctx_r2.lineWeightDropdownConfig)("dropdownClass", "dropdown-menu-fullwidth");
} }
function FundChartAnnotationStylingToolbarComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-simple-dropdown", 15);
    i0.ɵɵlistener("handler", function FundChartAnnotationStylingToolbarComponent_ng_template_3_Template_ycn_simple_dropdown_handler_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectFontSize($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(1, "ycn-color-picker", 13);
    i0.ɵɵlistener("setColorHandler", function FundChartAnnotationStylingToolbarComponent_ng_template_3_Template_ycn_color_picker_setColorHandler_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectTextColor($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "ycn-color-picker", 16);
    i0.ɵɵlistener("setColorHandler", function FundChartAnnotationStylingToolbarComponent_ng_template_3_Template_ycn_color_picker_setColorHandler_2_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectFillColor($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 5)(4, "div", 17);
    i0.ɵɵlistener("click", function FundChartAnnotationStylingToolbarComponent_ng_template_3_Template_div_click_4_listener() { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.editTextHandler.emit()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("buttonClass", "btn btn-secondary")("config", ctx_r2.fontSizeDropdownConfig)("dropdownClass", "dropdown-menu-fullwidth");
    i0.ɵɵadvance();
    i0.ɵɵproperty("buttonClass", "btn-block")("currentColor", ctx_r2.selectedTextColor)("dropdownClass", "tool")("iconToggle", "icon-tool-text-color");
    i0.ɵɵadvance();
    i0.ɵɵproperty("buttonClass", "btn-block")("currentColor", ctx_r2.selectedFillColor)("dropdownClass", "tool")("dropdownMenuClass", "dropdown-menu-right")("iconToggle", "icon-tool-circle-outline");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-edit");
} }
/**
 * Fund Chart Annotation Styling Toolbar Component
 *
 * Controls for editing and styling a selected annotation on the fund chart.
 *
 * Input Properties:
 *  selectedAnnotationName: display name for the currently selected fund chart annotation,
 *                          e.g. Circle, Trend Segment, Arrow Line, etc.
 *  selectedAnnotationType: determines which toolbar options are visible
 */
export class FundChartAnnotationStylingToolbarComponent {
    constructor() {
        this.deleteHandler = new EventEmitter();
        this.editTextHandler = new EventEmitter();
        this.fillColorChangeHandler = new EventEmitter();
        this.fontSizeChangeHandler = new EventEmitter();
        this.lineColorChangeHandler = new EventEmitter();
        this.lineWeightChangeHandler = new EventEmitter();
        this.textColorChangHandler = new EventEmitter();
        this.fontSizeChoices = ['11', '12', '13', '14', '16', '18'];
        this.fontSizeDropdownConfig = {
            title: {
                label: this.selectedFontSize,
            },
            list: this.fontSizeChoices.map((fontSize) => {
                return { type: 'option', label: fontSize, value: fontSize };
            }),
        };
        this.lineWeightChoices = ['1', '2', '3', '4', '5'];
        this.lineWeightDropdownConfig = {
            title: {
                label: this.selectedLineWeight,
            },
            list: this.lineWeightChoices.map((lineWeight) => {
                return { type: 'option', label: lineWeight, value: lineWeight };
            }),
        };
    }
    ngAfterViewInit() {
        ['touchstart', 'touchmove', 'touchend', 'touchcancel'].forEach((touchEventType) => {
            this.dragHandle.nativeElement.addEventListener(touchEventType, translateTouchEventToMouseEvent, true);
        });
        let startX = null;
        let startY = null;
        let translationX = 0;
        let translationY = 0;
        let resetLocation = false;
        let dragHandleObserver;
        const dragHandler = (event) => {
            const newX = event.clientX - startX;
            const newY = event.clientY - startY;
            this.toolbar.nativeElement.style.transform = `translate(${newX + translationX}px, ${newY + translationY}px)`;
        };
        this.dragHandle.nativeElement.addEventListener('mousedown', (event) => {
            event.preventDefault();
            const transformation = getComputedStyle(this.toolbar.nativeElement).getPropertyValue('transform');
            if (transformation) {
                const matrix = new DOMMatrixReadOnly(transformation);
                translationX = matrix.m41;
                translationY = matrix.m42;
            }
            startX = event.clientX;
            startY = event.clientY;
            // Observe the drag handle so that we can reset the location
            // of the toolbar if it is dragged off-screen
            dragHandleObserver = new window.IntersectionObserver(([entry]) => {
                if (entry.intersectionRatio < 1.0) {
                    resetLocation = true;
                }
                else {
                    resetLocation = false;
                }
            }, {
                threshold: [1.0],
            });
            dragHandleObserver.observe(this.dragHandle.nativeElement);
            document.addEventListener('mousemove', dragHandler);
            document.addEventListener('mouseup', () => {
                if (resetLocation) {
                    this.toolbar.nativeElement.style.transform = 'translate(0px, 0px)';
                }
                dragHandleObserver.unobserve(this.dragHandle.nativeElement);
                document.removeEventListener('mousemove', dragHandler);
            });
        });
    }
    ngOnChanges(changes) {
        if (changes.selectedFontSize?.currentValue) {
            this.fontSizeDropdownConfig.title.label = this.selectedFontSize;
        }
        if (changes.selectedLineWeight?.currentValue) {
            this.lineWeightDropdownConfig.title.label = this.selectedLineWeight;
        }
    }
    selectFontSize(newFontSize) {
        if (newFontSize === this.selectedFontSize) {
            return;
        }
        this.fontSizeChangeHandler.emit(newFontSize);
    }
    selectTextColor(newTextColor) {
        this.textColorChangHandler.emit(newTextColor);
    }
    selectLineWeight(newLineWeight) {
        if (newLineWeight === this.selectedLineWeight) {
            return;
        }
        this.lineWeightChangeHandler.emit(newLineWeight);
    }
    selectLineColor(newLineColor) {
        this.lineColorChangeHandler.emit(newLineColor);
    }
    selectFillColor(newFillColor) {
        this.fillColorChangeHandler.emit(newFillColor);
    }
}
FundChartAnnotationStylingToolbarComponent.ɵfac = function FundChartAnnotationStylingToolbarComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartAnnotationStylingToolbarComponent)(); };
FundChartAnnotationStylingToolbarComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartAnnotationStylingToolbarComponent, selectors: [["ycn-fund-chart-annotation-styling-toolbar"]], viewQuery: function FundChartAnnotationStylingToolbarComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toolbar = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dragHandle = _t.first);
    } }, inputs: { selectedAnnotationName: "selectedAnnotationName", selectedAnnotationType: "selectedAnnotationType", selectedFontSize: "selectedFontSize", selectedTextColor: "selectedTextColor", selectedLineWeight: "selectedLineWeight", selectedLineColor: "selectedLineColor", selectedFillColor: "selectedFillColor" }, outputs: { deleteHandler: "deleteHandler", editTextHandler: "editTextHandler", fillColorChangeHandler: "fillColorChangeHandler", fontSizeChangeHandler: "fontSizeChangeHandler", lineColorChangeHandler: "lineColorChangeHandler", lineWeightChangeHandler: "lineWeightChangeHandler", textColorChangHandler: "textColorChangHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 12, vars: 4, consts: [["toolbar", ""], ["textStylingToolbar", ""], ["toolbarDragHandle", ""], [1, "toolbar", "toolbar-horizontal", 2, "top", "56px", "right", "10px"], [4, "ngIf", "ngIfElse"], [1, "tool"], ["data-test-id", "delete-text-handler", 1, "btn", "btn-secondary", 3, "click"], ["ycnIcon", "", 3, "name"], [1, "tool", "toolbar-dragger"], [1, "btn", "btn-secondary"], [1, "tool", "tool-title"], ["data-test-id", "selected-annotation-type", 1, "btn", "width-112"], [1, "text-default", 3, "textContent"], [3, "setColorHandler", "buttonClass", "currentColor", "dropdownClass", "iconToggle"], [1, "tool", "dropdown", 3, "handler", "buttonClass", "config", "dropdownClass"], ["data-test-id", "select-font-size", 1, "tool", "dropdown", 3, "handler", "buttonClass", "config", "dropdownClass"], [3, "setColorHandler", "buttonClass", "currentColor", "dropdownClass", "dropdownMenuClass", "iconToggle"], ["data-test-id", "edit-text-handler", 1, "btn", "btn-secondary", 3, "click"]], template: function FundChartAnnotationStylingToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 3, 0);
        i0.ɵɵtemplate(2, FundChartAnnotationStylingToolbarComponent_ng_container_2_Template, 6, 8, "ng-container", 4)(3, FundChartAnnotationStylingToolbarComponent_ng_template_3_Template, 6, 13, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(5, "div", 5)(6, "div", 6);
        i0.ɵɵlistener("click", function FundChartAnnotationStylingToolbarComponent_Template_div_click_6_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.deleteHandler.emit()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(7, "svg", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(8, "div", 8)(9, "div", 9, 2);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(11, "svg", 7);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const textStylingToolbar_r5 = i0.ɵɵreference(4);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.selectedAnnotationType === "line_or_shape")("ngIfElse", textStylingToolbar_r5);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("name", "icon-delete");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("name", "icon-tool-dragger");
    } }, dependencies: [i1.NgIf, i2.ColorPickerComponent, i3.IconDirective, i4.SimpleDropdownComponent], encapsulation: 2 });
